<template>
    <!-- Google's line for a form that runs reCAPTCHA while its badge is hidden (3 November 2026: the footer's
         "protected by reCAPTCHA" box went, at the owner's word; the badge is hidden site-wide, so the forms say it) -->
    <p class="recaptcha-note">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Terms of Service</a> apply.</p>
</template>

<script>
export default { name: 'RecaptchaNote' };
</script>

<style>
/* the forms' own paragraph styles are larger: the note keeps its size */
p.recaptcha-note { flex: 1 1 100%; margin: 12px 0 0 !important; font-size: 12px !important; line-height: 1.5 !important; color: #6B6C73 !important; text-align: center; }
p.recaptcha-note a { color: inherit !important; font-size: inherit !important; text-decoration: underline; }
</style>
